export default __webpack_public_path__ + "static/media/dark-galaxy.ccf7b41e7e6e783509382ccbdbb3685c.svg";